import ConnectorScheduleDialog from "./ConnectorScheduleDialog";

const ConnectorSchedulePropertiesPanel = ({formId, uiSchema, connectorScheduleSchema, saveConnectorScheduleData, formData, readOnly, handleFormChange }) => {
    return (
        <div>
            <ConnectorScheduleDialog formId={formId} uiSchema={uiSchema} scheduleSchema={connectorScheduleSchema}
              saveConnectorScheduleData={saveConnectorScheduleData} formData={formData}
              handleFormChange={handleFormChange} readOnly={readOnly}/>
              
          </div>

    );
}

export default ConnectorSchedulePropertiesPanel;